// extracted by mini-css-extract-plugin
module.exports = {"Container":"styles_Container__2wssq","Wrapper":"styles_Wrapper__X3k2B","ItemName":"styles_ItemName__2vShP","RemoveButton":"styles_RemoveButton__1qAjw"};